import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "common/AuthProvider";

// Access is granted when the user matches ANY listed role OR holds ANY listed permission.
//
// Permissions were added so an area can be gated on a real, grantable permission rather than a
// hardcoded role list. The two are a union rather than an either/or so an area can name its
// permission without dropping the roles that already reached it -- which also means the app
// keeps working if it deploys ahead of the migration that seeds the permission.
//
// Passing neither leaves the route open, as before.
// Both default to empty so callers can pass either, both, or neither.
const ProtectedRoute = ({ roles = [], permissions = [], children }) => {
  const { isUserInRole, userHasPermission } = useContext(AuthContext);

  const handleAuth = () => {
      const gated = (roles && roles.length > 0) || (permissions && permissions.length > 0);
      if (!gated) {
        return children ? children : <Outlet/>;
      }

      let found = false;

      if (roles) {
        for (let i = 0; i < roles.length; i++) {
          if (isUserInRole(roles[i])) {
            found = true;
            break;
          }
        }
      }

      if (!found && permissions) {
        for (let i = 0; i < permissions.length; i++) {
          if (userHasPermission(permissions[i])) {
            found = true;
            break;
          }
        }
      }

      // not authorized so redirect to home page
      if (!found) {
        return <Navigate to={{ pathname: "/" }} />;
      }

      // authorized so return component
      return children ? children : <Outlet/>;
  }

  return (handleAuth() );

};
export default ProtectedRoute;
